import React from 'react';

/** Uzun metin sütunları — ekrana göre esnek genişlik, aşağı doğru sarar */
export const FLEX_WRAPPED_TEXT_CELL_CLASS =
  'align-top min-w-0 max-w-[14rem] sm:max-w-[18rem] lg:max-w-[22rem] break-words whitespace-normal leading-snug';

/** Bakım kayıtları Açıklama / envanter Not — aynı sütun genişliği */
export const flexWrappedTextColumnDef = (header, accessorKey) => ({
  header,
  accessorKey,
  size: 288,
  minSize: 224,
  maxSize: 352,
  headerClassName: 'align-top',
  cellClassName: FLEX_WRAPPED_TEXT_CELL_CLASS,
  cell: ({ getValue }) => <WrappedTextCell value={getValue()} />,
});

export const WrappedTextCell = ({ value }) => {
  if (!value) return '—';
  return (
    <span className="block break-words whitespace-normal leading-snug">
      {value}
    </span>
  );
};
